import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import {
  PaymentMethodExceptionLimitUpdateRequestPayload,
  PaymentMethodExceptionLimit,
} from '@/models/ps-management/exception-limit.model';

export default
class UpdatePaymentMethodExceptionLimitRequest extends ApiResourceMethod<PaymentMethodExceptionLimit> {
  public perform(payload: PaymentMethodExceptionLimitUpdateRequestPayload): Promise<{}> {
    return this.performer.requestWithMapper(
      {
        url: `paymentMethodSettings/${payload.paymentMethodSettingsId}/extendedLimit/${payload.exceptionLimitId}`,
        data: payload.paymentMethodExceptionData,
      },
      (response: BaseResponse<PaymentMethodExceptionLimit>): PaymentMethodExceptionLimit => {
        return response.data;
      },
    );
  }
}
